import { useEffect, useState } from "react";
import MutualFundHeader from "../../../components/import/mutualFund/MutualFundHeader.jsx";
import Breadcrumbs from "../../../components/ui/Breadcrumbs.jsx";
import MutualFundConfig from "./MutualFundConfig.jsx";
import axios from "axios";
import { errorNotify } from "../../../Services/Notification.js";
import ImportSchemePopup from "../../../components/import/mutualFund/ImportSchemePopup.jsx";

const getMutualFundDataAPIURL = `${process.env.REACT_APP_API_URL}api/service-tracker/mf-master/`;
const MutualFund = () => {
  const [renderKey, setRenderKey] = useState(0);
  const [data, setData] = useState([]);
  const [filter, setFilter] = useState();
  const [loading, setLoading] = useState();
  const [isImportPopupOpen, setIsImportPopupOpen] = useState(false);

  // API CONFIG
  const headers = {
    Authorization: `Bearer ${
      sessionStorage.getItem("subscriberToken")
        ? sessionStorage.getItem("subscriberToken")
        : sessionStorage.getItem("token")
    }`,
    "Content-Type": "application/json",
  };

  const getMutualFundData = async () => {
    setLoading(true);
    try {
      if (filter?.bookclose_recorddate && filter?.nse_exdate) {
        const payload = {
          start_date: filter?.bookclose_recorddate,
          end_date: filter?.nse_exdate,
          status: "All",
          sgmt: "All",
          src: "All",
        };
        const res = await axios.post(getMutualFundDataAPIURL, payload, {
          headers,
        });

        if (!res.data.error) {
          const formatedDateData = res.data.data
            ?.sort((a, b) => new Date(b.date) - new Date(a.date))
            ?.map((item) => ({
              ...item,
              date: item.date,
              status: item?.corp_action?.operation_status,
              op_cnt: item?.corp_action?.op_cnt,
              ip_cnt: item?.corp_action?.ip_cnt,
              file_name: item?.corp_action?.file_name,
            }));
          setData(formatedDateData);
          setLoading(false);
        } else {
          errorNotify(res.data.message);
          setLoading(false);
        }
      } else if (filter?.bookclose_recorddate && !filter?.nse_exdate) {
        errorNotify("Please select end date");
      } else if (!filter?.bookclose_recorddate && filter?.nse_exdate) {
        errorNotify("Please select start date");
      } else if (!filter?.bookclose_recorddate && !filter?.nse_exdate) {
        errorNotify("Please select start and end date");
      }
      setLoading(false);
    } catch (err) {
      errorNotify("Something went wrong");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (filter?.bookclose_recorddate || filter?.nse_exdate) {
      getMutualFundData();
    } else if (!filter) {
      setData([]);
    }
  }, [filter?.bookclose_recorddate, filter?.nse_exdate, renderKey]);

  const breadcrumbs = ["Home", "Import", "Mutual Fund"];

  return (
    <div className=" app-container min-h-[65vh] pb-[60px] pt-[100px]">
      <Breadcrumbs items={breadcrumbs} />

      <MutualFundHeader
        setFilter={setFilter}
        setIsImportPopupOpen={setIsImportPopupOpen}
      />
      <MutualFundConfig tableData={data} loading={loading} />
      <ImportSchemePopup
        isOpen={isImportPopupOpen}
        onClose={() => setIsImportPopupOpen(false)}
        url={`import-mf-scheme`}
        title="Import MF Scheme"
      />
    </div>
  );
};

export default MutualFund;
